module.exports = __webpack_public_path__ + "static/img/on9.e4a3b3b6.png";